import {firestoreAction} from 'vuexfire';
import {db} from '../firebase';
import {Logger} from '../plugins/logger';
import {firestore} from 'firebase/app';
import moment from 'moment';
import {hoursMinutes} from '../lib/time';

const log = Logger.get('feeds');

export default {
  namespaced: true,
  state: {
    latest: [],
    today: []
  },
  getters: {
    feedPath(state, getters, rootState, rootGetters) {
      const linkedEmail = rootGetters['user/linkedTo'];
      const userEmail = rootGetters['auth/email'];
      const email = linkedEmail ? linkedEmail : userEmail;
      return `users/${email}/feeds`;
    },
    latestFeed(state) {
      const last = state.latest;
      if (Array.isArray(last) && last.length === 1) {
        return last[0];
      }
      return null;
    },
    timeSinceFeed(state, getters, rootState, rootGetters) {
      const last = getters.latestFeed;
      if (!last) {
        return moment.duration(0);
      }
      const now = rootGetters['time/now'];
      const feedAt = moment.utc(last.startedAt.toDate());
      const diff = moment.duration(feedAt.diff(now));
      return hoursMinutes(diff);
    },
    todaysFeeds(state) {
      return state.today;
    },
    todaysFeedCount(state) {
      return state.today.length;
    }
  },
  actions: {
    bindLatest: firestoreAction(({bindFirestoreRef, unbindFirestoreRef, getters}) => {
      unbindFirestoreRef('latest');
      const feeds = getters.feedPath;
      const query = db.collection(feeds)
          .orderBy('startedAt', 'desc')
          .limit(1);
      log.log('bindLatest', feeds);
      return bindFirestoreRef('latest', query);
    }),
    bindToday: firestoreAction(({bindFirestoreRef, unbindFirestoreRef, getters}) => {
      unbindFirestoreRef('today');
      const feeds = getters.feedPath;

      const start = moment().startOf('day');
      const end = moment().endOf('day');
      const query = db.collection(feeds)
          .orderBy('startedAt', 'asc')
          .where('startedAt', '>=', firestore.Timestamp.fromDate(start.toDate()))
          .where('startedAt', '<=', firestore.Timestamp.fromDate(end.toDate()));
      log.log('bindToday', feeds);
      return bindFirestoreRef('today', query);
    }),
    getFeedsFor({getters, rootGetters}, date) {
      log.debug('getFeedsFor', date);
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }
      const feeds = getters.feedPath;

      const start = moment(date, 'YYYY-MM-DD').startOf('day');
      const end = moment(date, 'YYYY-MM-DD').endOf('day');
      const query = db.collection(feeds)
          .orderBy('startedAt', 'asc')
          .where('startedAt', '>=', firestore.Timestamp.fromDate(start.toDate()))
          .where('startedAt', '<=', firestore.Timestamp.fromDate(end.toDate()));

      return query.get();
    },
    addFeed({getters, rootGetters}, feed) {
      log.debug('editFeed', feed);
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }

      const feeds = db.collection(getters.feedPath);
      const time = moment(feed.startedAt);
      feed.startedAt = firestore.Timestamp.fromDate(time.toDate());
      return feeds.add(feed);
    },
    startFeed({getters, rootGetters}, side) {
      log.debug('startFeed', side);
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }
      const feeds = db.collection(getters.feedPath);
      return feeds.add({
        startedAt: firestore.Timestamp.fromDate(new Date()),
        first: side,
        both: false
      });
    },
    setLatestBoth({getters, rootGetters}) {
      log.debug('setLatestBoth');
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }
      const last = getters['latestFeed'];
      if (!last) {
        return Promise.reject('no latest feed');
      }
      const feeds = db.collection(getters.feedPath);
      log.debug(last, last.id);
      return feeds.doc(last.id).update({both: true});
    },
    editFeed({getters, rootGetters}, {id, feed}) {
      log.debug('editFeed', id, feed);
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }
      const time = moment(feed.startedAt);
      feed.startedAt = firestore.Timestamp.fromDate(time.toDate());
      const feeds = db.collection(getters.feedPath);
      return feeds.doc(id).set(feed);
    },
    deleteFeed({getters, rootGetters}, id) {
      log.debug('deleteFeed', id);
      if (!rootGetters['auth/isAuthenticated']) {
        return Promise.reject('not authenticated');
      }
      const feeds = db.collection(getters.feedPath);
      return feeds.doc(id).delete();
    }
  }
}
